export default __webpack_public_path__ + "static/media/SWT1180.34I-43201_-26214_0.56056300.jpg";